import { Stack } from "@mui/material";
import TimelineRow from "./TimelineRow";
import TaskHeading from "./TaskHeading";

/** A task and the steps observed under it, in execution order. */
export default function TaskGroup({ task, rows = [], streaming = false }) {
  return (
    <Stack sx={{ gap: 0.75 }}>
      <TaskHeading task={task} streaming={streaming} />
      {rows.map((row) => (
        <TimelineRow key={row.id} row={row} streaming={streaming} />
      ))}
    </Stack>
  );
}
